<!-- <app-navigation></app-navigation> -->

<!-- Top Placeholder: jss-menu -->
<sc-placeholder
  name="jss-eq-menu"
  [rendering]="route"
  (loaded)="onPlaceholderLoaded($event)"
></sc-placeholder>

<div>
  <ng-container *ngIf="state === LayoutState.Layout">
    <app-visitor-identification></app-visitor-identification>
    <sc-placeholder
      name="jss-main"
      [rendering]="route"
      (loaded)="onPlaceholderLoaded($event)"
    ></sc-placeholder>
  </ng-container>

  <app-not-found
    *ngIf="state === LayoutState.NotFound"
    [errorContextData]="errorContextData"
  ></app-not-found>
  <app-server-error *ngIf="state === LayoutState.Error"></app-server-error>
</div>

<!-- Bottom Placeholder: jss-footer -->
<sc-placeholder
  name="jss-eq-footer"
  [rendering]="route"
  (loaded)="onPlaceholderLoaded($event)"
></sc-placeholder>
